export default "__VITE_ASSET__DYjnulIi__"